module.exports = __webpack_public_path__ + "img/compass.086c8236.jpg";